const PageHeader = ({ text }) => {
  return (
    <div>
      <section className="page-header">
        <h3>{text}</h3>
      </section>
    </div>
  )
}

export default PageHeader
